import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { isAuthenticated } from "../utils/permissions";
import Layout from "../components/Layout";

export default function Bookmarks() {
  const { userType } = useContext(AuthContext);
  
  // Check if user is authenticated
  if (!isAuthenticated(userType)) {
    return (
      <Layout>
        <div className="p-4 flex items-center justify-center h-full">
          <div className="text-xl text-gray-500">
            Please sign in to view your bookmarks.
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="p-4 max-w-4xl mx-auto">
        <h1 className="text-3xl font-serif mb-6">Your Bookmarks</h1>
        
        {/* Placeholder for bookmarks feature */}
        <div className="bg-white rounded-lg shadow-sm p-8">
          <p className="text-gray-500">
            Bookmarks feature coming soon. This page will show articles you've saved.
          </p>
        </div>
      </div>
    </Layout>
  );
}